<template>
  <section id="slugger" class="section" ref="section">
    <div class="section__content">
      <div class="wrap">
        <div class="section__title" data-aos="fade-up">
          <span class="span-1">擁抱成長動能</span>
          <br />
          <span class="span-2 section__span--bold">加入美股常勝軍!</span>
        </div>

        <div class="table-box" data-aos="fade-up">
          <div class="tabs">
            <div
              v-for="(tab, index) in tabs"
              :key="index"
              @click="activeTab = index"
              :class="{ active: activeTab === index }"
              :style="{
                backgroundImage: `url(${
                  isSmallScreen ? tab.name : tab.namePC
                })`,
              }"
              class="tabs__list"
            >
              <img
                v-if="activeTab === index"
                :src="isSmallScreen ? tab.active : tab.activePC"
                class="active-indicator"
                alt=""
              />
            </div>
          </div>

          <div class="tab-content">
            <transition name="fade">
              <div
                v-show="activeTab === 0"
                class="tab-content__item"
                :class="{ active: activeTab === 0 }"
              >
                <div class="tab-content__title">
                  Q4旺季加上降息紅利，美股成長可期
                </div>
                <div class="tab-content__chart chart">
                  <!-- <div class="tab-content__chart-text">
                    美國標普500成長指數 本益比走勢
                  </div> -->
                  <img src="../assets/images/s1_chart-1.png" alt="" />
                </div>
                <div class="secure-text">
                  資料來源:(左圖)Bloomberg，2015/Q1-2025/Q3；(右圖)FedWatch，2025/09/24，中國信託投信整理，2025/09/24。<span
                    class="highlight"
                    >以上指數為含息報酬指數，僅供參考用途，其歷史績效不應被視為現在或未來表現及績效的保證，亦不代表基金現在或未來之報酬率。本文提及之經濟走勢預測不必然代表基金之績效，基金投資風險請詳閱金基公開說明書。
                  </span>
                </div>
              </div>
            </transition>

            <transition name="fade">
              <div
                v-show="activeTab === 1"
                class="tab-content__item"
                :class="{ active: activeTab === 1 }"
              >
                <div class="tab-content__title">
                  美國大型企業ROE*領先全球，<br
                    class="inactive"
                  />更具投資吸引力
                </div>
                <div class="tab-content__discript">
                  <p>
                    根據彭博預估，2025 及 2026 年股東報酬率 (ROE*)
                    <br
                      class="inactive"
                    />表現皆優於其他主要國家及區域，將持續領先全球。
                  </p>
                </div>
                <div class="tab-content__chart chart">
                  <!-- <div class="tab-content__chart-text">
                    各區域國家股東權益報酬率(ROE*)預估%
                  </div> -->
                  <img src="../assets/images/s1_chart-2.png" alt="" />
                </div>
                <div class="secure-text">
                  資料來源:
                  Bloomberg，中國信託投信整理，2025/09/08。*ROE為股東權益報酬率。<span
                    class="highlight"
                    >此資料僅為預估數據，不為未來投資獲利之保證。</span
                  >
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';
import { mixins } from '@/utils/mixins';

export default {
  name: 'Slugger',
  mixins: [mixins],
  props: {},
  data: () => {
    return {
      activeTab: 0,
      isSmallScreen: window.innerWidth <= 1080,
      tabs: [
        {
          name: require('../assets/images/s1_tab1_m.png'),
          active: require('../assets/images/s1_tab1_active_m.png'),
          namePC: require('../assets/images/s1_tab1.png'),
          activePC: require('../assets/images/s1_tab1_active.png'),
        },
        {
          name: require('../assets/images/s1_tab2_m.png'),
          active: require('../assets/images/s1_tab2_active_m.png'),
          namePC: require('../assets/images/s1_tab2.png'),
          activePC: require('../assets/images/s1_tab2_active.png'),
        },
      ],
    };
  },
  computed: {
    // ...mapState([])
  },
  methods: {
    // ...mapActions([]),
    updateScreenType() {
      this.isSmallScreen = window.innerWidth <= 1080;
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateScreenType);

    this.sectionInView();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenType);
  },
  components: {},
};
</script>

<style lang="scss">
$assets: '~@/assets/images/slugger/';

#slugger {
  width: 100%;
  max-width: 1920px;
  background-image: url('../assets/images/s1_bg.jpg');
  background-repeat: repeat-y;
  background-size: calc(2500px * 0.8) calc(2490px * 0.8);
  background-position: center top;
  padding: 70px 0 calc(175px * 0.8) 0;
  @include tabletX {
    // background-size: calc(vwX(2500) * 0.8) calc(vwX(2490) * 0.8);
    padding: vwX(70) 0 calc(vwX(175) * 0.8) 0;
  }
  @include tablet {
    width: 100%;
    background-image: url('../assets/images/s1_bg_m.jpg');
    background-size: 100% auto;
    padding: vwM(235) 0 vwM(260) 0;
  }
  .section__content {
    .section__title {
      .section__span--bold {
        letter-spacing: (letterSpacing(40, 58px));
        @include tablet {
          letter-spacing: (letterSpacing(40, vwM(58)));
        }
        .shrink {
          display: none;
          margin: 0 -70px;
          @include tabletX {
            margin: 0 vwX(-70);
          }
          @include tablet {
            display: inline-block;
            margin: 0 vwM(-41);
          }
        }
      }
    }

    .table-box {
      border-bottom: 20px solid #009eb5;
      margin-top: 18px;
      padding: 0;
      @include tablet {
        border-bottom: vwM(20) solid #009eb5;
        margin-top: vwM(18);
      }
    }

    .tabs__list {
      width: 651px;
      height: 209px;
      background-size: cover;
      background-position: center top;
      background-repeat: no-repeat;
      @include tabletX {
        width: vwX(651);
        height: vwX(209);
      }
      @include tablet {
        width: vwM(475);
        height: vwM(285);
      }
      .active-indicator {
        width: 833px;
        height: 270px;
        position: absolute;
        @include tabletX {
          width: vwX(833);
          height: vwX(270);
        }
        @include tablet {
          width: vwM(613);
          height: vwM(320);
        }
      }
      &:nth-child(1) .active-indicator {
        top: 0;
        left: 0;
      }
      &:nth-child(2) .active-indicator {
        top: 0;
        right: 0;
      }
    }

    .tab-content {
      .tab-content__item {
        position: absolute;
        top: 33%;
        left: 3.2%;
        width: 100%;
        opacity: 0;
        transition: opacity 0s ease;
        &.active {
          position: relative;
          top: unset;
          left: unset;
          opacity: 1;
        }
      }
      .tab-content__item:nth-child(1) {
        .tab-content__chart {
          padding-top: 60px;
          @include tabletX {
            padding-top: vwX(60);
          }
          @include tablet {
            padding-top: 0;
          }
          .tab-content__chart-text {
            letter-spacing: letterSpacing(120, 17px);
            top: 118px;
            @include tabletX {
              letter-spacing: letterSpacing(120, vwX(17));
              top: vwX(118);
            }
            @include tablet {
              letter-spacing: letterSpacing(120, vwM(22));
              top: vwM(38);
              left: 22.5%;
            }
          }
          img {
            width: 1187px;
            // height: 624px;
            @include tabletX {
              width: vwX(1187);
              // height: vwX(624);
            }
            @include tablet {
              // width: vwM(1539);
              // height: vwM(809);
              width: vwM(885);
              // height: vwM(465);
              padding-top: vwM(10);
            }
          }
        }
      }
      .tab-content__item:nth-child(2) {
        .tab-content__discript {
          margin-top: 56px;
          @include tabletX {
            margin-top: vwX(56);
          }
          @include tablet {
            margin-top: vwM(30);
          }
        }
        .tab-content__chart {
          padding-top: 73px;
          margin-left: 0;
          @include tabletX {
            padding-top: vwX(73);
          }
          @include tablet {
            padding-top: vwM(20);
          }
          .tab-content__chart-text {
            letter-spacing: letterSpacing(120, 17px);
            top: 28px;
            @include tabletX {
              letter-spacing: letterSpacing(120, vwX(17));
              top: vwX(28);
            }
            @include tablet {
              letter-spacing: letterSpacing(120, vwM(22));
              top: vwM(50);
              left: 26%;
            }
          }
          img {
            width: 1079px;
            height: 613px;
            @include tabletX {
              width: vwX(1079);
              height: vwX(613);
            }
            @include tablet {
              // width: vwM(1444);
              // height: vwM(820);
              width: vwM(885);
              height: vwM(503);
              padding-top: vwM(10);
            }
          }
        }
      }

      .secure-text {
        width: 1200px;
        margin-top: 70px;
        @include tabletX {
          width: vwX(1200);
          margin-top: vwX(70);
        }
        @include tablet {
          width: vwM(840);
          margin-top: vwM(40);
        }
      }
    }

    .secure-text {
      color: #3f3f3f;
      .highlight {
        color: #009eb5;
      }
    }

    .inactive.mb-none {
      @include tablet {
        display: none;
      }
    }
  }
}
// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.3s ease;
// }
// .fade-enter,
// .fade-leave-to {
//   opacity: 0;
//   // display: block; // 確保過渡期間元素保持可見
// }
</style>
